module.exports = __webpack_public_path__ + "img/middle.a3316780.png";